import React from 'react';
import GenericCrudPage from '../components/GenericCrudPage';

// Only PrescriptionsPage remains here. Ortho/Perio/Implants/Education stubs
// were deleted — they were duplicates of ClinicalPage internal tabs.
// Their hub cards now route into ClinicalPage with `initialTab` set.
export const PrescriptionsPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="prescriptions"
    title="Prescriptions"
    fields={[
      { key: 'patientName', label: 'Patient Name', required: true },
      { key: 'doctorName', label: 'Prescribed By' },
      { key: 'date', label: 'Date', type: 'date' },
      { key: 'medicines', label: 'Medicines', type: 'textarea', required: true },
      { key: 'instructions', label: 'Instructions', type: 'textarea' },
      { key: 'status', label: 'Status', type: 'select', options: ['active', 'completed', 'cancelled'], default: 'active' },
    ]}
    listColumns={['date', 'patientName', 'doctorName', 'status']}
  />
);
